<template>
  <div class="flex flex-direction align-center">
    <el-form
      ref="userInfoForm"
      :model="userInfo"
      :rules="userInfoRules"
      :label-position="UI.isMobile ? 'top' : 'left'"
      :label-width="UI.isMobile ? undefined : '120px'"
      style="width: 90%;"
    >
      <el-form-item label="免冠头像" prop="avatar">
        <MediaUpload
          ref="avatar"
          :action="uploadUrl + '/upload/avatar'"
          :suffixList="['.png', '.jpg']"
          :file="userInfo.avatar"
          @success="handlerUploadSuccess('avatar')"
        ></MediaUpload>
        <div class="flex text-gray" v-if="!userInfo.avatar">
          <span>最佳尺寸:106x150px(小一寸)</span>
        </div>
      </el-form-item>
      <el-form-item label="姓名" prop="name">
        <el-input
          placeholder="请输入姓名"
          clearable
          v-model="userInfo.name"
        ></el-input>
      </el-form-item>
      <el-form-item label="性别" prop="sex">
        <el-radio-group v-model="userInfo.sex">
          <el-radio :label="0">男</el-radio>
          <el-radio :label="1">女</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="籍贯" prop="native_place">
        <el-cascader
          v-model="userInfo.native_place"
          :options="cityOptions"
        ></el-cascader>
      </el-form-item>
      <el-form-item label="民族" prop="nation">
        <el-select filterable v-model="userInfo.nation" placeholder="请选择">
          <el-option
            :label="item.label"
            :value="item.label"
            v-for="(item, index) in nationList"
            :key="index"
          ></el-option>
        </el-select>
      </el-form-item>

      <!--      <el-form-item label="手机号码" prop="mobile">
        <el-input
          placeholder="请输入手机号码"
          clearable
          v-model="userInfo.mobile"
        ></el-input>
      </el-form-item> -->

      <el-form-item label="证件类型" prop="identifier_type">
        <el-select v-model="userInfo.identifier_type" placeholder="请选择">
          <el-option label="身份证" :value="0"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="证件号码" prop="identifier_code">
        <el-input
          placeholder="请输入证件号码"
          clearable
          v-model="userInfo.identifier_code"
          @input="getBirthday()"
        ></el-input>
      </el-form-item>

      <el-form-item label="出生日期" prop="birthday">
        <el-date-picker
          disabled
          value-format="yyyy-MM-dd"
          v-model="userInfo.birthday"
          type="date"
          placeholder="选择日期时间"
        ></el-date-picker>
      </el-form-item>

      <el-form-item label="身份证扫描件" prop="identifier_image">
        <MediaUpload
          ref="identifier_image"
          :action="uploadUrl + '/upload/identifier_image'"
          :suffixList="['.png', '.pdf', '.jpg']"
          :file="userInfo.identifier_image"
          @success="handlerUploadSuccess('identifier_image')"
        ></MediaUpload>
      </el-form-item>

      <!--      <el-form-item label="邮箱" prop="email">
        <el-input
          placeholder="请输入邮箱"
          clearable
          v-model="userInfo.email"
        ></el-input>
      </el-form-item> -->

      <!--      <el-form-item label="通讯地址" prop="address">
        <el-input
          placeholder="请输入通讯地址"
          clearable
          v-model="userInfo.address"
        ></el-input>
      </el-form-item> -->

      <el-form-item label="户籍证明" prop="household_image">
        <MediaUpload
          ref="household_image"
          :action="uploadUrl + '/upload/household_image'"
          :suffixList="['.png', '.pdf', '.jpg']"
          :file="userInfo.household_image"
          @success="handlerUploadSuccess('household_image')"
        ></MediaUpload>
      </el-form-item>

      <el-form-item label="代表资格协议" prop="contract">
        <MediaUpload
          ref="contract"
          :action="uploadUrl + '/upload/contract'"
          :suffixList="['.png', '.pdf', '.jpg']"
          :file="userInfo.contract"
          @success="handlerUploadSuccess('contract')"
        ></MediaUpload>
      </el-form-item>

      <el-form-item label="协议起始时间" prop="contract_start_time">
        <el-date-picker
          value-format="yyyy-MM-dd"
          v-model="userInfo.contract_start_time"
          type="date"
          placeholder="选择日期时间"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="协议终止时间" prop="contract_end_time">
        <el-date-picker
          value-format="yyyy-MM-dd"
          v-model="userInfo.contract_end_time"
          type="date"
          placeholder="选择日期时间"
        ></el-date-picker>
      </el-form-item>
    </el-form>

    <el-button
      class="login-button padding-xs margin-top"
      type="primary"
      size="mini"
      @click="submit()"
    >
      提交审核
    </el-button>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import { mobileRegex, emailRegex, idCardRegex } from '@/utils/reConsts.js';
import MediaUpload from '@/components/upload/mediaUpload.vue';
import { baseUrl } from '@/utils/consts.js';
import { showErrorMsg, showSuccessMsg } from '@/utils/uiUtils.js';
import { addPlayer, editPlayer } from '@/servers/org.js';
import citys from '@/utils/city.js';
import nationList from '@/utils/nation.js';

export default {
  components: {
    MediaUpload,
  },

  props: {
    userInfoPre: {
      type: Object,
      default: function() {
        return {};
      },
    },
  },

  watch: {
    userInfoPre: {
      deep: true,
      handler: function(newVal) {
        console.log(newVal);
        this.userInfo = newVal;
      },
    },
  },

  data() {
    let validateMobile = (_, value, callback) => {
      if (!mobileRegex.test(value)) {
        callback(new Error('请输入正确的手机号码'));
      } else {
        callback();
      }
    };

    let validateEmail = (_, value, callback) => {
      if (!emailRegex.test(value)) {
        callback(new Error('请输入正确的邮箱'));
      } else {
        callback();
      }
    };

    let validateIdCard = (_, value, callback) => {
      if (!idCardRegex.test(value)) {
        callback(new Error('请输入正确的身份证号码'));
      } else {
        callback();
      }
    };

    return {
      userInfo: this.userInfoPre ? this.userInfoPre : {},
      cityOptions: citys,
      nationList: nationList,
      uploadUrl: baseUrl,
      userInfoRules: {
        name: [
          {
            required: true,
            message: '请输入姓名',
            trigger: 'blur',
          },
        ],
        avatar: [
          {
            required: true,
            message: '请上传免冠头像',
            trigger: 'blur',
          },
        ],
        sex: [
          {
            required: true,
            message: '请输入性别',
            trigger: 'blur',
          },
        ],
        native_place: [
          {
            required: true,
            message: '请输入籍贯',
            trigger: 'blur',
          },
        ],
        nation: [
          {
            required: true,
            message: '请输入民族',
            trigger: 'blur',
          },
        ],
        // mobile: [
        //   {
        //     required: true,
        //     message: '请输入手机',
        //     trigger: 'blur',
        //   },
        //   {
        //     validator: validateMobile,
        //     trigger: 'blur',
        //   },
        // ],
        identifier_type: [
          {
            required: true,
            message: '请输入证件类型',
            trigger: 'blur',
          },
        ],
        identifier_code: [
          {
            required: true,
            message: '请输入证件号码',
            trigger: 'blur',
          },
          {
            validator: validateIdCard,
            trigger: 'blur',
          },
        ],
        // email: [
        //   {
        //     required: true,
        //     message: '请输入邮箱',
        //     trigger: 'blur',
        //   },
        //   {
        //     validator: emailRegex,
        //     trigger: 'blur',
        //   },
        // ],
        // address: [
        //   {
        //     required: true,
        //     message: '请输入通讯地址',
        //     trigger: 'blur',
        //   },
        // ],
        contract: [
          {
            required: true,
            message: '请上传代表资格协议',
            trigger: 'blur',
          },
        ],
        identifier_image: [
          {
            required: true,
            message: '请上传身份证扫描件',
            trigger: 'blur',
          },
        ],
        household_image: [
          {
            required: true,
            message: '请上传户籍证明',
            trigger: 'blur',
          },
        ],
        contract_start_time: [
          {
            required: true,
            message: '请选择协议时间',
            trigger: 'blur',
          },
        ],
        contract_end_time: [
          {
            required: true,
            message: '请选择协议时间',
            trigger: 'blur',
          },
        ],
      },
    };
  },

  computed: {
    ...mapState(['User', 'UI']),
  },

  methods: {
    ...mapMutations(['getUserState']),

    handlerUploadSuccess: function(key) {
      this.userInfo[key] = this.$refs[key].uploadRes;
    },

    getBirthday: function() {
      if (idCardRegex.test(this.userInfo.identifier_code)) {
        this.userInfo.birthday =
          this.userInfo.identifier_code.substring(6, 10) +
          '-' +
          this.userInfo.identifier_code.substring(10, 12) +
          '-' +
          this.userInfo.identifier_code.substring(12, 14);
      }
    },

    submit: function() {
      let that = this;
      this.$refs.userInfoForm.validate((valid) => {
        if (valid) {
          if (this.userInfo.id) {
            editPlayer(this.userInfo.id, this.userInfo, function(res) {
              showSuccessMsg(res);
              that.getUserState();
              that.$emit('success');
            });
          } else {
            addPlayer(this.userInfo, function(res) {
              showSuccessMsg(res);
              that.getUserState();
              that.$emit('success');
            });
          }
        } else {
          showErrorMsg('请检查输入的参数.');
        }
      });
    },
  },
};
</script>
<style scoped>
.login-button {
  width: 200px;
}

.verify-bar-area {
  border-radius: 30px;
}
</style>



// WEBPACK FOOTER //
// src/pages/index/info/userInfoEdit.vue